import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { Row, Col } from "antd";
import { DemonstrativoReceitaEDespesaItem } from "core/features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";
import colors from "core/resources/theme/colors";

interface RelatorioItemProps {
  item: DemonstrativoReceitaEDespesaItem;
  index: number;
  indent: number;
  startBg: "white" | "gray";
  onClick: (v: any) => void;
  somarSubcategorias?: boolean;
}

function RelatorioItem({
  item,
  index = 0,
  indent = 0,
  startBg = "white",
  onClick,
  somarSubcategorias,
}: RelatorioItemProps) {
  const alternateBg = startBg === "white" ? "gray" : "white";

  const thisBg = index % 2 === 0 ? startBg : alternateBg;

  return (
    <>
      <Box
        key={`${indent}-${index}`}
        as={Row}
        gutter={2}
        py={2}
        display="flex"
        alignItems="center"
        bg={thisBg === "gray" ? "#EEE" : "white"}
        onClick={onClick}
        cursor="pointer"
      >
        <Box
          key={index}
          as={Col}
          xs={16}
          color={item.items.length ? colors.black : colors.black600}
        >
          <Text
            fontWeight={item.items.length ? "bold" : "regular"}
            pl={`${indent * 12}px`}
          >
            {item.breadcrumb} {item.nome}
          </Text>
        </Box>

        <Box key={index} as={Col} xs={4}>
          {item.items.length && !item.valor ? null : (
            <Text fontWeight={item.items.length ? "bold" : "regular"}>
              {item.porcentagem ? `${+item.porcentagem}`.replace(".", ",") : ""}
              {item.porcentagem ? "%" : ""}
            </Text>
          )}
        </Box>

        <Box key={index} as={Col} xs={4}>
          <Text
            fontWeight={item.items.length ? "bold" : "regular"}
            textAlign="right"
          >
            {somarSubcategorias && item.items.length
              ? formatMoney((item.valor ?? 0) + item.valorItems)
              : item.valor
              ? formatMoney(item.valor)
              : null}
          </Text>
        </Box>
      </Box>
    </>
  );
}

export default RelatorioItem;
